import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class HelperService {

    private helperService = new BehaviorSubject<Partial<HelperData>>({});
    public helperService$ = this.helperService.asObservable();

    doNotLoadHistoryReports() {
        this.helperService.next({
            doNotLoadReports: true
        });
    }

    loadHistoryReports() {
        this.helperService.next({
            doNotLoadReports: false
        });
    }

    getLoadHisotryReportsStatus(): boolean {
        return this.helperService.getValue().doNotLoadReports;
    }


}

interface HelperData {
    doNotLoadReports: boolean;
}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/helper/helper.service.ts